import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const HowToCharge = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('battery_item2'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div className="bind-device-faq">
            <div className="bind-device-faq-marginH25">
                {/* <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('charge_faq_step1')}</span> */}
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('charge_faq_step1_detail1')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}charge1.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
            {/* <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('charge_faq_step1_detail2')}</span>
            </div>
            <div style={{ height: 25 }} /> */}
            {/* <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('charge_faq_step2')}</span>
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('charge_faq_step2_detail')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}charge2.png`} style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div> */}
            <div style={{ height: 20 }} />
        </div>
    </div>
}

export default HowToCharge